import {observer} from 'mobx-react';
import React, {Component} from 'react';
import {MenuProps} from 'semantic-ui-react';
import {AnimatedActionSubmenu} from '../../../../components/Common/ActionsMenu';
import withClickOutside from 'react-onclickoutside';
import {
    changeParent,
    setScreenChanged
} from '../../Design/derivatives/TreeDesign/actions/Collection';
import chosen from '../../../../images/chosen.png';

@observer
class MoveMenu extends Component<MenuProps & any, any> {
    moveField = (field, folder) => {
        setScreenChanged(this.props.field);
        changeParent(field, folder);
    };

    handleClickOutside() {
        const {closeSubmenu} = this.props;
        closeSubmenu();
    }

    getFolders = tree => {
        const flat = [];
        if (Array.isArray(tree)) {
            tree.forEach(item => {
                if (item.type === 'tab') {
                    flat.push(item);
                }

                if (item?.collection?.fields) {
                    flat.push(...this.getFolders(item?.collection?.fields));
                }
            });
        }
        return flat;
    };

    render() {
        const {field = {}} = this.props;
        const folders = this.getFolders(field.screen.collection.fields);

        return (
            <AnimatedActionSubmenu open={this.props.open}>
                {folders.map(folder => {
                    const className = `move-option ${
                        field.parentField.name === folder.name && 'selected'
                    }`;
                    return (
                        <div
                            key={folder.name}
                            className={className}
                            onClick={() => this.moveField(field, folder)}
                        >
                            <img src={chosen} alt="" />
                            {folder.title}
                        </div>
                    );
                })}
            </AnimatedActionSubmenu>
        );
    }
}

export const MoveSubmenu = withClickOutside(MoveMenu);
